module.exports = __webpack_public_path__ + "static/coffeehat-a15c41be5352e9857b0ea5b588ff895f.jpeg";